// extracted by mini-css-extract-plugin
export default {"container":"check_container__b0nPy","check":"check_check__F1Scz","label":"check_label__yzlAZ"};